import React from 'react';
import PropTypes from 'prop-types';
import styles from './style.scss';

const Error404 = () => {

    return (
        <div className="error-404-page">
            <h1>Error 404</h1>
        </div>
    )
}

Error404.propTypes = {
    location: PropTypes.object
};

export default Error404;
